// Imports
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) return { selector: to.hash }
    if (savedPosition) return savedPosition

    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: () => import('@/layouts/home/Index.vue'),
      children: [
        {
          path: '/',
          name: 'Home',
          component: () => import('@/views/home/Index.vue'),
        },
        {
          path: '/about-us',
          name: 'About',
          component: () => import('@/views/about/Index.vue'),
          meta: { src: require('@/assets/about.jpg') },
        },
        {
          path: '/services',
          name: 'Services',
          component: () => import('@/views/services/Index.vue'),
          meta: { src: require('@/assets/services.jpg') },
        },
        {
          path: '/blog',
          name: 'Blog',
          component: () => import('@/views/blog/Index.vue'),
          meta: { src: require('@/assets/services.jpg') },
        },
        {
          path: '/promotions',
          name: 'Promotion',
          component: () => import('@/views/promotion/Index.vue'),
          meta: { src: require('@/assets/about.jpg') },
        },
        {
          path: '/partners',
          name: 'Partner',
          component: () => import('@/views/partner/Index.vue'),
          meta: { src: require('@/assets/partner.jpg') },
        },
        {
          path: '/csr',
          name: 'corporatesocial',
          component: () => import('@/views/corporatesocial/Index.vue'),
          meta: { src: require('@/assets/partner.jpg') },
        },
        {
          path: '/study-singapore',
          name: 'Study Singapore',
          component: () => import('@/views/study-singapore/Index.vue'),

        },
        {
          path: '/coporate-social-responsibility',
          name: 'corporatesocial',
          component: () => import('@/views/corporatesocial/Index.vue'),
          meta: { src: require('@/assets/partner.jpg') },
        },

        {
          path: '/academy-full-stack-developer',
          name: 'Academy',
          component: () => import('@/views/academy/Index.vue'),
          meta: { src: require('@/assets/partner.jpg') },
        },
        {
          path: '/career',
          name: 'Career',
          component: () => import('@/views/career/Index.vue'),
          meta: { src: require('@/assets/partner.jpg') },
        },
        {
          path: '/contact-us',
          name: 'Contact',
          component: () => import('@/views/contact-us/Index.vue'),
          meta: { src: require('@/assets/sVisa.jpg') },
        },
        {
          path: '/privacy-policy',
          name: 'PrivacyPolicy',
          component: () => import('@/views/privacy-policy/Index.vue'),
          meta: { src: require('@/assets/contact.jpg') },
        },
      ],
    },
  ],
})

export default router
